export default "__VITE_ASSET__CRtgipX1__"